module.exports = __webpack_public_path__ + "static/media/icon-head-popup.6a5d3a7b.png";